// src/slices/8-Contact-us/thunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;
const CONTACT_URL = `${API_URL}/contact-us`;

export const sendContact = createAsyncThunk("contact/send", async (data, { rejectWithValue }) => {
  try {
    const res = await axios.post(CONTACT_URL, data);
    return res.data;
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message);
  }
});
